import PropTypes from 'prop-types';
import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { store } from '@febos-io/auth';
import { Button } from '@febos-io/design';
import { providers } from '@febos-io/common';

import { useTranslation } from '../../hooks';
import { setPatients } from '../../store';

export function ButtonAddNewPatient({
  innerRef,
  innerProps,
  isDisabled,
  children,
  selectProps,
  setValue,
}) {
  const dispatch = useDispatch();

  const companyId = useSelector(store.getCompanyId);

  const { t, } = useTranslation();
  const { openModal, } = providers.useModalContext();
  const onAfterClose = useCallback(({ fromModal, }) => {
    if (fromModal && typeof fromModal !== 'boolean') {
      dispatch(setPatients({
        companyId,
        patients: {
          [fromModal.id]: fromModal,
        },
      }));
      setValue(fromModal);
    }
  }, [companyId, dispatch, setValue]);
  const showButton = useMemo(
    () => {
      return !!(selectProps.inputValue?.length && !selectProps.isLoading);
    },
    [selectProps.inputValue, selectProps.isLoading]
  );
  return !isDisabled ? (
    <div ref={innerRef} {...innerProps} className="shadow bg-white rounded">
      {children}
      {showButton && (
        <div className="text-center border-top">
          <Button
            className="btn btn-block btn-link"
            onClick={() => openModal('new-patient-app', {}, { onAfterClose, })}
            icon="user-plus"
            size="sm"
            outline
          >
            {t('New Patient')}
          </Button>
        </div>
      )}
    </div>
  ) : null;
}

ButtonAddNewPatient.propTypes = {
  innerRef: PropTypes.func,
  innerProps: PropTypes.object,
  selectProps: PropTypes.object,
  isDisabled: PropTypes.bool,
  setValue: PropTypes.func,
  children: PropTypes.node,
};

export default ButtonAddNewPatient;
